"use strict";
(self["webpackChunkheraclea_olive_oil"] = self["webpackChunkheraclea_olive_oil"] || []).push([[524],{

/***/ 524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Slider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(797);




function Slider({ wrapper }) {
  const { classes } = window.config

  const defaultSettings = {
    centeredSlidesBounds: true,
    cssMode: true,
    slidesPerView: 'auto',
    breakpoints: {
      768: {
        centeredSlidesBounds: true,
        cssMode: false,
        grabCursor: true,
      },
    },
  }

  let settings = null,
    swiper = null

  ;(function init() {
    buildSettings()

    swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(wrapper, settings)
    // $(swiper.el).addClass(classes.active)

    initEventListeners()
    autoDisable()

    if (getBreakpointsWithDisabled().length) {
      listenForDisable()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', listenForDisable)
    }
  })()

  function buildSettings() {
    // Use the default config if one isn't provided
    settings = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') : defaultSettings
    settings = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') : defaultSettings
    if (typeof settings === 'string') {
      try {
        settings = JSON.parse(settings)
      } catch (e) {
        settings = defaultSettings
      }
    }

    // Set "cssMode" to "auto" by default
    if (!('cssMode' in settings) || settings.cssMode == 'auto') {
      settings.cssMode = (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)()
    }
  }

  function getBreakpointsWithDisabled() {
    if (settings.breakpoints) {
      return Object.keys(settings.breakpoints).filter((breakpoint) => {
        return settings.breakpoints[breakpoint].disable
      })
    } else {
      return []
    }
  }

  function breakpointMatches(breakpoint) {
    return window.matchMedia(`(min-width: ${breakpoint}px)`)
  }

  function listenForDisable() {
    const breakpoints = getBreakpointsWithDisabled()

    if (breakpoints.length) {
      breakpoints.forEach(function (breakpoint) {
        const breakpointMatch = breakpointMatches(breakpoint)

        if (breakpointMatch.matches) {
          swiper.destroy(false)
        } else if (swiper.destroyed) {
          swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(wrapper, settings)
        }
      })
    }
  }

  function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('swiper:requestInstance', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('swiper:recieveInstance', [swiper])
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', '[data-hook="toggle-playback"]', togglePlayback)

    swiper.on('resize', autoDisable)
  }

  function autoDisable() {
    const slidesOverflow = jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.el).innerWidth() < swiper.virtualSize

    if (swiper.passedParams.autoDisable != false && !swiper.params.loop && !slidesOverflow) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.el).removeClass(classes.active)

      // @jake - how to prefix these classes ? should they be added to the window.config.classes object?
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.wrapperEl).addClass('!transform-none >:!shrink').css({
        transform: '',
        width: 'fit-content',
        marginInline: 'auto',
      })

      swiper.disable()
      swiper.update()
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.el).addClass(classes.active)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiper.wrapperEl).removeClass('!transform-none >:!shrink')

      swiper.enable()
      swiper.update()
    }
  }

  function togglePlayback(e) {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass(classes.active)) {
      swiper.autoplay.stop()
    } else {
      swiper.autoplay.start()
    }
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).toggleClass(classes.active)
  }

  return swiper
}


/***/ })

}]);